import React from "react";
import PropTypes from "prop-types";
import StaticCardActionBtn from "../../../../components/StaticCardActionBtn";
import "./style.scss";

export default function LastAnswerByType({ typeAnswer, className, title }) {
  const cls = ["in-game-page__main__swipe-wrapper__wrapper__last-answer"];
  if (className) cls.push(className);
  LastAnswerByType.propTypes = {
    typeAnswer: PropTypes.number,
    className: PropTypes.string,
    title: PropTypes.string,
  };
  return (
    <div className={cls.join(" ")}>
      <StaticCardActionBtn typeAnswer={typeAnswer} />
      <div className="in-game-page__main__swipe-wrapper__wrapper__last-answer__title">
        {title}
      </div>
    </div>
  );
}
